export default function DeafIcon({ stroke = "#626060" }: { stroke?: string }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.986 19.6713C22.2865 18.1362 24 15.7712 24 12.8571C24 10.7733 23.1571 8.7748 21.6569 7.3013C20.1566 5.8278 18.1217 5 16 5C13.8783 5 11.8434 5.8278 10.3431 7.3013C8.84285 8.7748 8 10.7733 8 12.8571V23.0012C8 25.1747 9.787 27 12 27C14.213 27 15.3415 25.7262 15.8645 25.0357C16.603 24.0629 17.95 21.0305 19.986 19.6713Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 18V12.2308C11 9.90385 13.25 8 16 8C18.75 8 21 9.90385 21 12.2308"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 14.8123C12.341 13.8496 15.2815 14.01 15.2815 14.01C16.6761 14.01 17.4899 15.5835 16.6761 16.7162C16.6761 16.7162 14.699 18.9838 14.4308 20"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
